
import URI from "urijs"

import I18n from "plugins/i18n-js"

const locale = I18n.locale
const WP_SITE = (() => {
  switch (locale){
    case "en":
      return `${window.location.protocol}//www.spacious.hk/en/blog/`
    case "zh-TW":
      return `${window.location.protocol}//www.spacious.hk/zh-tw/blog/`
    case "zh-HK":
      return `${window.location.protocol}//www.spacious.hk/zh-tw/blog/`
    case "zh-CN":
      return `${window.location.protocol}//www.spacious.hk/zh-tw/blog/`
    default: return `${window.location.protocol}//www.spacious.hk/en/blog/`
  }
})()

const HEADLINE_TAG = "headline"
const TICKER_TAG = "hot-news"
const OVERSEA_TAG = "international"

const tags_api_uri = () =>
  URI(WP_SITE)
  .segment("wp-json/wp/v2/tags")
  .clone()

const posts_api_uri = () =>
  URI(WP_SITE)
  .segment("wp-json/wp/v2/posts")
  .clone()

export default {
  HEADLINE_TAG,
  TICKER_TAG,
  OVERSEA_TAG,
  tags_api_uri,
  posts_api_uri,
}
